
import { Grid } from '../board';
import { BoardElement } from '../types';
import { findLongestSubarray } from './findLongestSubarray';

export function checkBoardAroundPoint(gridArray: Grid, { x, y }: { x: number, y: number }) {
    const dioganalUpDown: Array<BoardElement> = [];
    const dioganalDownUp: Array<BoardElement> = [];
    const horizontal: Array<BoardElement> = [];
    const vertcal: Array<BoardElement> = [];
    
    const checkMatrixSize = 4;
    for (let i = y - checkMatrixSize; i <= y + checkMatrixSize; i++) {
        for (let j = x - checkMatrixSize; j <= x + checkMatrixSize; j++) {
            if (y - i === x - j) {
                dioganalUpDown.push({ value: gridArray[i]?.[j], position: { i, j }});
            }
            if (i - y === x - j) {
                dioganalDownUp.push({ value: gridArray[i]?.[j], position: { i, j }});
            }
            if (i === y) {
                horizontal.push({ value: gridArray[i]?.[j], position: { i, j }});
            }
            if (j === x) {
                vertcal.push({ value: gridArray[i]?.[j], position: { i, j }});
            }
        }
    }

    let maxLength = 0, winArray;
    [dioganalUpDown, dioganalDownUp, horizontal, vertcal].some((arr) => {
        const subarray = findLongestSubarray(arr, { value: gridArray[y][x], position: { i: y, j: x }});
        if (subarray.length > maxLength) {
            maxLength = subarray.length;
            winArray = subarray;
        }
        if (subarray.length >= 5) {
            return true;
        }
        return false;
    });
    return {
        maxLength,
        winArray
    };
}